__turbopack_context__.v({
  "banner": "_5ioK6a_banner",
  "wrapper": "_5ioK6a_wrapper",
});
